import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { Button, Card } from '@agro1desenvolvimento/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { loginService } from '@agro1desenvolvimento/apis-js-package';
import { App } from '../../@types/app';
import AppsService from '../../services/apps';
import notifications from '../../services/notifications';

const AppsPage: React.FC<PropTypes> = () => {
  const [apps, setApps] = useState<App[]>([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const carregaApps = async () => {
    setApps(
      (await AppsService.allAPPs()).sort(
        (appA, appB) => appA.description.localeCompare(appB.description),
      ),
    );
  };

  const logout = async () => {
    await loginService.setToken(null);
    history.replace('/login');
  };

  const onCardClick = async (app: App) => {
    if (loading) return;

    try {
      setLoading(true);
      window.location.href = await AppsService.externalAppUrl(app.internalUrl);
    } catch (error) {
      notifications.error({ message: 'Falha ao carregar URL da aplicação.' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    carregaApps().then(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="apps-page">
        <div className="apps-header">
          <h1 className="apps-title">Selecione a aplicação que deseja acessar!</h1>
          <p className="apps-subtitle">
            Para retornar a esta tela, clique em
            {' '}<strong>&quot;Retornar aos APPs&quot;</strong>
            {' '}no menu do usuário
          </p>
        </div>
        <div className="apps-loading">
          <div className="apps-spinner" />
        </div>
      </div>
    );
  }

  if (apps.length === 0) {
    return (
      <div className="apps-page">
        <div className="apps-header">
          <h1 className="apps-title">Selecione a aplicação que deseja acessar!</h1>
          <p className="apps-subtitle">
            Para retornar a esta tela, clique em
            {' '}<strong>&quot;Retornar aos APPs&quot;</strong>
            {' '}no menu do usuário
          </p>
        </div>
        <div className="apps-empty">
          Nenhum aplicativo disponível
        </div>
      </div>
    );
  }

  return (
    <div className="apps-page">
      <div className="apps-header">
        <Button className="back-button" onClick={() => logout()}>
          <FontAwesomeIcon icon="arrow-left" />
          VOLTAR PARA TELA DE LOGIN
        </Button>
        <h1 className="apps-title">Selecione a aplicação que deseja acessar!</h1>
        <p className="apps-subtitle">
          Para retornar a esta tela, clique em
          {' '}<strong>&quot;Retornar aos APPs&quot;</strong>
          {' '}no menu do usuário
        </p>
      </div>
      <div className="apps-content">
        {apps.filter((app) => app.app !== 'integrations-api').map((app) => (
          <div
            key={app.description}
            onClick={() => onCardClick(app)}
            style={{ cursor: 'pointer' }}
            role="button"
            tabIndex={0}
          >
            <Card className="app-card">
              <img
                src={app.avatarUrl}
                alt="APP logo"
                className="app-logo"
              />
              <h2 className="app-title">
                {app.description}
              </h2>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

type PropTypes = RouteComponentProps<Record<string, never>>;

export default AppsPage;
